import React from 'react'
import Header from 'components/pages/Header'
import Footer from 'components/nav/Footer'

const Layout = ({ children }) => {
  return (
    <div>
      <Header />
      <main>{children}</main>
      <Footer />
    </div>
  )
}

export default Layout
